import { getResults } from '../../api'
import { GET, POST } from '../../util/fetch-methods'

export const resendEmailChangeValidation = () => {
    return getResults('/api/v1/users/verify/email/', POST())
}

export const validateLegacy = () => {
    const requestInit = POST(
        JSON.stringify({
            source: 2,
            platform: 'web',
        })
    )
    requestInit.headers!['Content-Type'] = 'application/json'
    return getResults('/api/v3/users/legacy/email', requestInit as RequestInit)
}

export const validateLegacyEmailCode = (code: string) => {
    return getResults('/api/v3/users/legacy/email/confirm/', POST({ code }, true))
}

export const validateLegacyStatus = () => {
    return getResults('/api/v3/users/legacy/email/status?platform=web&source=2', GET)
}
